import {
    GET_MODULES_STRUCTURE_REQUEST,
    GET_MODULES_STRUCTURE_REQUEST_SUCCESS,
    GET_MODULES_STRUCTURE_REQUEST_FAILURE,
    FILTER_GROUP_MODULES,
    SET_ALL_FIELDS_PERMISSIONS_REQUEST,
    SET_ALL_FIELDS_PERMISSIONS_REQUEST_SUCCESS,
    SET_ALL_FIELDS_PERMISSIONS_REQUEST_FAILURE,
} from '../constants/get_group_data.constants';

export const getModulesStructureRequest = id => ({ type: GET_MODULES_STRUCTURE_REQUEST, id });
export const getModulesStructureSuccess = payload => ({ type: GET_MODULES_STRUCTURE_REQUEST_SUCCESS, payload });
export const getModulesStructureFailure = error => ({ type: GET_MODULES_STRUCTURE_REQUEST_FAILURE, error });
export const filterGroupModules = payload => ({ type: FILTER_GROUP_MODULES, payload });
export const setAllFieldsPermissionsRequest = target => ({ type: SET_ALL_FIELDS_PERMISSIONS_REQUEST, target });
export const setAllFieldsPermissionsSuccess = payload => ({ type: SET_ALL_FIELDS_PERMISSIONS_REQUEST_SUCCESS, payload });
export const setAllFieldsPermissionsFailure = error => ({ type: SET_ALL_FIELDS_PERMISSIONS_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/actions/get_modules_structure.actions.js